import { LineChart } from '@wundo/ui';
import type { MetricDataPoint } from '@/lib/dashboard.ts';
import { ChartCard } from './ChartCard.tsx';
import { sumPoints } from './funnelMath.ts';
import { snapshotDate } from './snapshotDates.ts';

export interface RecordingsCardProps {
  bot: MetricDataPoint[];
  physical: MetricDataPoint[];
  info: string;
}

/** Finished recordings per day, the notetaker bot and the laptop microphone side by side. */
export function RecordingsCard({ bot, physical, info }: RecordingsCardProps) {
  const days = [
    ...new Set([...bot, ...physical].map((point) => point.period_end)),
  ].sort();
  const valueOn = (points: MetricDataPoint[], day: string) =>
    Number(points.find((point) => point.period_end === day)?.value ?? 0);

  return (
    <ChartCard
      title='Notetaker recordings'
      info={info}
      description='Recordings that finished with a transcript, per day.'
      aside={
        <p className='text-xs text-ink-muted'>
          {`Online ${sumPoints(bot)} · physical ${sumPoints(physical)} in period`}
        </p>
      }
    >
      <LineChart
        ariaLabel='Notetaker recordings'
        labels={days.map(snapshotDate)}
        series={[
          { label: 'Online (notetaker)', data: days.map((day) => valueOn(bot, day)) },
          {
            label: 'Physical (microphone)',
            data: days.map((day) => valueOn(physical, day)),
          },
        ]}
        showLegend
        height={200}
      />
    </ChartCard>
  );
}
